import api from '../../services/api'

const state = {
  users: [],
  totalUsers: 0,
  currentPage: 1,
  totalPages: 0,
  loading: false,
  roles: [
    { value: 'Admin', label: 'Administrateur', description: 'Accès complet à toutes les fonctionnalités' },
    { value: 'Responsable Planning', label: 'Responsable Planning', description: 'Gestion des plannings et des équipes' },
    { value: 'Commercial', label: 'Commercial', description: 'Gestion des clients et des ventes' },
    { value: 'Magasinier', label: 'Magasinier', description: 'Gestion des stocks et des inventaires' },
    { value: 'Technicien', label: 'Technicien', description: 'Accès aux outils techniques et maintenance' },
    { value: 'Financier', label: 'Financier', description: 'Gestion financière, validation des dépenses et contrôle des caisses' }
  ]
}

const mutations = {
  SET_USERS(state, { users, pagination }) {
    state.users = users
    state.totalUsers = pagination.total
    state.currentPage = pagination.page
    state.totalPages = pagination.pages
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  ADD_USER(state, user) {
    state.users.unshift(user)
    state.totalUsers++
  },
  UPDATE_USER(state, updatedUser) {
    const index = state.users.findIndex(user => user._id === updatedUser._id)
    if (index !== -1) {
      state.users.splice(index, 1, updatedUser)
    }
  },
  DELETE_USER(state, userId) {
    state.users = state.users.filter(user => user._id !== userId)
    state.totalUsers--
  }
}

const actions = {
  async fetchUsers({ commit }, { page = 1, limit = 10, role = '', actif = '', search = '' } = {}) {
    commit('SET_LOADING', true)
    
    try {
      const params = new URLSearchParams()
      params.append('page', page)
      params.append('limit', limit)
      if (role) params.append('role', role)
      if (actif !== '') params.append('actif', actif)
      if (search) params.append('search', search)

      const response = await api.get(`/users?${params.toString()}`)
      
      commit('SET_USERS', {
        users: response.data.utilisateurs,
        pagination: response.data.pagination
      })
      
      return response.data
    } catch (error) {
      const message = error.response?.data?.message || 'Erreur lors de la récupération des utilisateurs'
      throw new Error(message)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createUser({ commit }, userData) {
    try {
      const response = await api.post('/users', userData)
      const { user } = response.data
      
      commit('ADD_USER', user)
      
      return { success: true, user }
    } catch (error) {
      const message = error.response?.data?.message || 'Erreur lors de la création de l\'utilisateur'
      throw new Error(message)
    }
  },

  async updateUser({ commit }, { id, userData }) {
    try {
      const response = await api.put(`/users/${id}`, userData)
      const { user } = response.data
      
      commit('UPDATE_USER', user)
      
      return { success: true, user }
    } catch (error) {
      const message = error.response?.data?.message || 'Erreur lors de la mise à jour de l\'utilisateur'
      throw new Error(message)
    }
  },

  async deleteUser({ commit }, userId) {
    try {
      const response = await api.delete(`/users/${userId}`)
      
      commit('DELETE_USER', userId)
      
      return { 
        success: true,
        produitsRetournes: response.data.produitsRetournes || 0,
        details: response.data.details || null
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Erreur lors de la suppression de l\'utilisateur'
      throw new Error(message)
    }
  },

  async bulkAction({ dispatch }, { action, userIds }) {
    try {
      await api.post('/admin/bulk-actions', { action, userIds })
      
      // Recharger la liste des utilisateurs
      await dispatch('fetchUsers')
      
      return { success: true }
    } catch (error) {
      const message = error.response?.data?.message || 'Erreur lors de l\'action en lot'
      throw new Error(message)
    }
  }
}

const getters = {
  users: state => state.users,
  totalUsers: state => state.totalUsers,
  currentPage: state => state.currentPage,
  totalPages: state => state.totalPages,
  loading: state => state.loading,
  roles: state => state.roles,
  getUserById: state => id => state.users.find(user => user._id === id)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
